import 'es6-promise/auto';
import Vue from 'vue';
import Vuex from 'vuex';

import access from './access.module';
import dashboard from './dashboard.module';
import visit from './visit.module';
import utils from './utils.module';
import skeleton from './skeleton.module';
import customerHistory from './customerHistory.module';
import business from './business.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    access,
    dashboard,
    visit,
    utils,
    skeleton,
    customerHistory,
    business,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js